import * as React from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import { UserAuth } from "../../context/AuthContext";
import Typography from "@mui/joy/Typography";
import { Link as RouterLink } from "react-router-dom";
import Link from '@mui/joy/Link';
import AddUser from "../../components/Forms/AddUser";

export default function AddUserPage() {
  const { userData } = UserAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (userData && userData?.role !== "super") {
      navigate("/unauthorized", { replace: true });
    }
  }, [userData, navigate]);

  if (!userData || userData?.role !== "super") {
    return null;
  }

  return (
    <DashboardLayout title="Add User" navigator={
      <Link
        underline="none"
        color="neutral"
        component={RouterLink}
        to="/manageuser"
        aria-label="Home"
      >
        <Typography fontWeight={500} fontSize={12}>
          Manage Users
        </Typography>
      </Link>
    }>
      {/* <AddUser /> */}
    </DashboardLayout>
  );
}
